module.exports = __webpack_public_path__ + "img/series_verde_pattern.3200a450.png";